import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { removeTable } from '../../../../actions/SeatingChartActions';
import './TableModal.less';

class DeleteTableModal extends Component {
  constructor(props) {
    super(props);
    this.renderListItems = this.renderListItems.bind(this);
  }
  renderListItems() {
    const { table } = this.props;
    const items = [];
    for (let i = 0; i < table.num_seats; i += 1) {
      const item = table.seats[i];
      if (!item.isEmpty) {
        items.push(<div key={i}>
          <span>{item.display_name}</span>
        </div>);
      }
    }
    return items;
  }
  render() {
    const { onCancel, onDelete, table } = this.props;

    return (
      <div>
        <div className="modal-header">
          <h3 className="modal-title">Delete Table</h3>
        </div>
        <div id="table-form" className="tableModal__form">
          <h3>{`Are You Sure You Want to Delete ${table.name}?`}</h3>
          <h4>By deleting this table, all guests currently seated at the table will be returned to the guest list.</h4>
          {this.renderListItems()}
          <div className="tableModal__buttonGroup">
            <button className="btn btn-secondary tableModal__delete-form" onClick={() => onCancel()}> Cancel</button>
            <button className="btn btn-danger tableModal__delete-form" onClick={() => onDelete(table.uuid)}> Delete</button>
          </div>
        </div>
      </div>
    );
  }
}

DeleteTableModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  table: PropTypes.shape({})
};

const mapDispatchToProps = (dispatch, ownProps) => (
  {
    onCancel: () => {
      ownProps.hideModalFn();
    },
    onDelete: (tableUuid) => {
      dispatch(removeTable(tableUuid)).then(() => {
        ownProps.hideModalFn();
      });
    }
  }
);

export default connect(
  null,
  mapDispatchToProps
)(DeleteTableModal);



/** WEBPACK FOOTER **
 ** ./src/components/manage/seatingchart/seatingChartModals/DeleteTableModal.jsx
 **/